import { Message, SendingStatus } from './message.model';

export class Device {
  id: string;
  internalId: string;
  name: string;
  identifier: string;
  endPoint: string;
  softwareVersion: string;
  model: string;
  description: string;
  lastCallDate: string;
  lastReadingRequestDate: string;
  lastConfigurationSendingDate: string;
  configurationVersion: Number;
  connector: string;
  sendingStatus: SendingStatus;
  loading: boolean;
  canRequestConfiguration: boolean;

  constructor(obj: any) {
    this.id = obj?.id;
    this.internalId = obj?.internalId;
    this.name = obj?.name;
    this.identifier = obj?.identifier;
    this.endPoint = obj?.endPoint;
    this.softwareVersion = obj?.softwareVersion;
    this.model = obj?.model;
    this.description = obj?.description;
    this.lastCallDate = obj?.lastCallDate;
    this.lastReadingRequestDate = obj?.lastReadingRequestDate;
    this.lastConfigurationSendingDate = obj?.lastConfigurationSendingDate;
    this.configurationVersion = obj?.configurationVersion;
    this.connector = obj?.connector;
    this.sendingStatus = SendingStatus.Unknown;
    this.loading = false;
    this.canRequestConfiguration = false;
    if (obj && obj !== null) {
      if (!obj.lastReadingRequestDate || obj.lastReadingRequestDate === null) {
        this.canRequestConfiguration = true;
      } else {
        const dt = new Date(obj.lastReadingRequestDate).getTime();
        const now = new Date().getTime();
        if (Math.floor((now - dt) / 60000) >= 10) {
          this.canRequestConfiguration = true;
        }
      }
    }
  }

  public get sendingStatusColor() : string {
    return Message.getColorByStatus(this.sendingStatus);
  }
}
